import { GET, POST, PUT, PATCH, DELETE, BaseApiGateWay, DataSerializer } from '@repo/alt/Services'
import { injectable, injectFromBase } from 'inversify'

import { ResourceImageFormat } from './models/Enums'
import { PromotionRewardType } from './models/Enums'
import { AttributeRequirementsStringType } from './models/Enums'
import { AttributeRequirementsBoolType } from './models/Enums'
import { AttributeRequirementsIntegerType } from './models/Enums'
import { AttributeRequirementsDecimalType } from './models/Enums'
import { AttributeRequirementsDictType } from './models/Enums'
import { AttributeRequirementsFileType } from './models/Enums'
import { SDEKOfficeType } from './models/Enums'
import { SDEKLang } from './models/Enums'
import { CdekCounterpartyType } from './models/Enums'
import { ContentType } from './models/Enums'
import { SortDirection } from './models/Enums'
import { CursorMode } from './models/Enums'
import { ContentResourceType } from './models/Enums'
import { LoyaltyLotKind } from './models/Enums'
import { LoyaltyTransactionType } from './models/Enums'
import { Notificationtype } from './models/Enums'
import { NotificationType } from './models/Enums'
import { Orderstatuspublic } from './models/Enums'
import { OrderStatusPublic } from './models/Enums'
import { OrderCancelledReason } from './models/Enums'
import { DeliveryMethodKind } from './models/Enums'
import { OrderDeliveryMethodCdekDtoKind } from './models/Enums'
import { OrderDeliveryMethodPickupDtoKind } from './models/Enums'
import { DayOfWeek } from './models/Enums'
import { OrderDeliveryMethodManualDtoKind } from './models/Enums'
import { AttributeRequirementsType } from './models/Enums'
import { OrderItemStatus } from './models/Enums'
import { OrderItemCancelledReason } from './models/Enums'
import { PaymentMoment } from './models/Enums'
import { PaymentAcquirer } from './models/Enums'
import { Deliverymethodkind } from './models/Enums'
import { ShowcasePageBlockCarouselDtoType } from './models/Enums'
import { PageBlockTextAlignment } from './models/Enums'
import { PageBlockCtaTargetType } from './models/Enums'
import { ShowcasePageBlockProductCollectionDtoType } from './models/Enums'
import { ImageResizeMode } from './models/Enums'
import { ImageResizeAnchorPosition } from './models/Enums'
import { RobotsPolicy } from './models/Enums'
import { Gender } from './models/Enums'
import { WebChannelAnalyticsConfig } from './models/WebChannelAnalyticsConfig'
import { WebChannelAnalyticsSection } from './models/WebChannelAnalyticsSection'
import { WebChannelCmpSection } from './models/WebChannelCmpSection'
import { AttributesListDto } from './models/AttributesListDto'
import { SignInCompletedResponse } from './models/SignInCompletedResponse'
import { WebChannelAuthConfig } from './models/WebChannelAuthConfig'
import { SignInRequest } from './models/SignInRequest'
import { SignInBeginResponse } from './models/SignInBeginResponse'
import { BeginChallengeResponse } from './models/BeginChallengeResponse'
import { SignUpRequest } from './models/SignUpRequest'
import { ConfirmChallengeRequest } from './models/ConfirmChallengeRequest'
import { MiniAppAuthRequest } from './models/MiniAppAuthRequest'
import { MiniAppAuthResponse } from './models/MiniAppAuthResponse'
import { MiniAppAccountChoiceResponse } from './models/MiniAppAccountChoiceResponse'
import { MiniAppAccountChoiceItem } from './models/MiniAppAccountChoiceItem'
import { MiniAppSelectAccountRequest } from './models/MiniAppSelectAccountRequest'
import { CartInfo } from './models/CartInfo'
import { CartProductListItemDto } from './models/CartProductListItemDto'
import { EntityRef } from './models/EntityRef'
import { WellKnownProductAttributesDict } from './models/WellKnownProductAttributesDict'
import { ResourceRef } from './models/ResourceRef'
import { ResourceImageInfoDto } from './models/ResourceImageInfoDto'
import { EntityRefOfString } from './models/EntityRefOfString'
import { UpdateCart } from './models/UpdateCart'
import { UpdateCartProduct } from './models/UpdateCartProduct'
import { CartPricingRequest } from './models/CartPricingRequest'
import { CartPricingLineRequest } from './models/CartPricingLineRequest'
import { CartPricingResponse } from './models/CartPricingResponse'
import { CartPricingLineResponse } from './models/CartPricingLineResponse'
import { CartAppliedPromotionDto } from './models/CartAppliedPromotionDto'
import { CartRejectedPromotionDto } from './models/CartRejectedPromotionDto'
import { SetPromoCodeRequest } from './models/SetPromoCodeRequest'
import { ChannelCategoriesDto } from './models/ChannelCategoriesDto'
import { CategoryAttributesListDto } from './models/CategoryAttributesListDto'
import { CategoryProductAttributeDto } from './models/CategoryProductAttributeDto'
import { AttributeDto } from './models/AttributeDto'
import { AttributeRequirementsString } from './models/AttributeRequirementsString'
import { AttributeRequirementsBool } from './models/AttributeRequirementsBool'
import { AttributeRequirementsInteger } from './models/AttributeRequirementsInteger'
import { AttributeRequirementsDecimal } from './models/AttributeRequirementsDecimal'
import { AttributeRequirementsDict } from './models/AttributeRequirementsDict'
import { AttributeRequirementsFile } from './models/AttributeRequirementsFile'
import { CdekSuggestCitiesRequestQuery } from './models/CdekSuggestCitiesRequestQuery'
import { SDEKSuggestCityDto } from './models/SDEKSuggestCityDto'
import { CdekCitiesByLocationRequestQuery } from './models/CdekCitiesByLocationRequestQuery'
import { CdekOfficesRequestQuery } from './models/CdekOfficesRequestQuery'
import { CdekLocation } from './models/CdekLocation'
import { ContentListRequestQuery } from './models/ContentListRequestQuery'
import { PageOfShowcaseContentListItemDto } from './models/PageOfShowcaseContentListItemDto'
import { PageMeta } from './models/PageMeta'
import { CursorPosition } from './models/CursorPosition'
import { ShowcaseContentListItemDto } from './models/ShowcaseContentListItemDto'
import { ShowcaseContentItemDto } from './models/ShowcaseContentItemDto'
import { ShowcaseContentSeoDto } from './models/ShowcaseContentSeoDto'
import { ShowcaseContentResourceDto } from './models/ShowcaseContentResourceDto'
import { ShowcaseContentSitemapEntryDto } from './models/ShowcaseContentSitemapEntryDto'
import { Enumsregistry } from './models/Enumsregistry'
import { FavoritesProductsListGetRequestQuery } from './models/FavoritesProductsListGetRequestQuery'
import { ProductListItemPage } from './models/ProductListItemPage'
import { ProductListItemDto } from './models/ProductListItemDto'
import { ListingOptionsOfFavoriteProductsFilterOptions } from './models/ListingOptionsOfFavoriteProductsFilterOptions'
import { FavoriteProductsFilterOptions } from './models/FavoriteProductsFilterOptions'
import { WebChannelFeedConfig } from './models/WebChannelFeedConfig'
import { ShowcaseLoyaltyWalletDto } from './models/ShowcaseLoyaltyWalletDto'
import { ShowcaseLoyaltyActiveLotDto } from './models/ShowcaseLoyaltyActiveLotDto'
import { ShowcaseLoyaltyTierStateDto } from './models/ShowcaseLoyaltyTierStateDto'
import { LoyaltyListTransactionsRequestQuery } from './models/LoyaltyListTransactionsRequestQuery'
import { PageOfShowcaseLoyaltyTransactionDto } from './models/PageOfShowcaseLoyaltyTransactionDto'
import { ShowcaseLoyaltyTransactionDto } from './models/ShowcaseLoyaltyTransactionDto'
import { NotificationsListRequestQuery } from './models/NotificationsListRequestQuery'
import { PageOfNotificationDto } from './models/PageOfNotificationDto'
import { NotificationDto } from './models/NotificationDto'
import { NotificationsListCountRequestQuery } from './models/NotificationsListCountRequestQuery'
import { ItemsCount } from './models/ItemsCount'
import { OrdersListRequestQuery } from './models/OrdersListRequestQuery'
import { PageOfOrderListDto } from './models/PageOfOrderListDto'
import { OrderListDto } from './models/OrderListDto'
import { StatusInfoOfOrderStatusPublic } from './models/StatusInfoOfOrderStatusPublic'
import { OrderDeliveryDto } from './models/OrderDeliveryDto'
import { OrderDeliveryMethodCdekDto } from './models/OrderDeliveryMethodCdekDto'
import { OrderCdekDeliveryTimes } from './models/OrderCdekDeliveryTimes'
import { OrderDeliveryMethodPickupDto } from './models/OrderDeliveryMethodPickupDto'
import { WarehouseWorkingHours } from './models/WarehouseWorkingHours'
import { WarehouseWorkingDay } from './models/WarehouseWorkingDay'
import { OrderDeliveryMethodManualDto } from './models/OrderDeliveryMethodManualDto'
import { OrderManualDeliveryAddressDto } from './models/OrderManualDeliveryAddressDto'
import { OrderPaymentDto } from './models/OrderPaymentDto'
import { OrderPromotionDto } from './models/OrderPromotionDto'
import { OrderItemListDto } from './models/OrderItemListDto'
import { OrderProductKeyAttributeSnapshot } from './models/OrderProductKeyAttributeSnapshot'
import { OrderItemInstanceShorDto } from './models/OrderItemInstanceShorDto'
import { StatusInfoOfOrderItemStatus } from './models/StatusInfoOfOrderItemStatus'
import { UpdateOrder } from './models/UpdateOrder'
import { UpdateOrderDeliveryCdek } from './models/UpdateOrderDeliveryCdek'
import { UpdateOrderDeliveryPickup } from './models/UpdateOrderDeliveryPickup'
import { UpdateOrderDeliveryManual } from './models/UpdateOrderDeliveryManual'
import { OrderManualDeliveryAddressWrite } from './models/OrderManualDeliveryAddressWrite'
import { UpdateOrderItem } from './models/UpdateOrderItem'
import { OrderAttributionWrite } from './models/OrderAttributionWrite'
import { OrderDto } from './models/OrderDto'
import { OrderItemDto } from './models/OrderItemDto'
import { OrderItemInstanceDto } from './models/OrderItemInstanceDto'
import { WebChannelOrdersConfig } from './models/WebChannelOrdersConfig'
import { WebChannelDeliveryMethodDto } from './models/WebChannelDeliveryMethodDto'
import { WebPickupPointDto } from './models/WebPickupPointDto'
import { PostalAddress } from './models/PostalAddress'
import { WebChannelPaymentMethodDto } from './models/WebChannelPaymentMethodDto'
import { OrderPayRequestV1 } from './models/OrderPayRequestV1'
import { ShowcasePageBlockCarouselDto } from './models/ShowcasePageBlockCarouselDto'
import { ShowcasePageBlockCarouselSlideDto } from './models/ShowcasePageBlockCarouselSlideDto'
import { ShowcasePageBlockCtaDto } from './models/ShowcasePageBlockCtaDto'
import { ShowcasePageBlockProductCollectionDto } from './models/ShowcasePageBlockProductCollectionDto'
import { ShowcaseProductCollectionListItemDto } from './models/ShowcaseProductCollectionListItemDto'
import { ProductCollectionsPreviewRequestQuery } from './models/ProductCollectionsPreviewRequestQuery'
import { ShowcaseProductCollectionPreviewDto } from './models/ShowcaseProductCollectionPreviewDto'
import { ShowcaseProductCollectionDto } from './models/ShowcaseProductCollectionDto'
import { ShowcaseProductCollectionSeoDto } from './models/ShowcaseProductCollectionSeoDto'
import { ProductsListGetRequestQuery } from './models/ProductsListGetRequestQuery'
import { ListingOptionsOfProductFilterOptions } from './models/ListingOptionsOfProductFilterOptions'
import { ProductFilterOptions } from './models/ProductFilterOptions'
import { ProductDto } from './models/ProductDto'
import { ProductAttributesGroupDto } from './models/ProductAttributesGroupDto'
import { EntityRefOfInt64 } from './models/EntityRefOfInt64'
import { ProductAttributeValueSlotDto } from './models/ProductAttributeValueSlotDto'
import { ProductAttributeRequirementsDto } from './models/ProductAttributeRequirementsDto'
import { ProductAttributeValueDto } from './models/ProductAttributeValueDto'
import { ProductVariantsDto } from './models/ProductVariantsDto'
import { ProductVariantDto } from './models/ProductVariantDto'
import { ProductVideoDto } from './models/ProductVideoDto'
import { ResourcesGetFileRequestQuery } from './models/ResourcesGetFileRequestQuery'
import { ResourcesGetFileLocationRequestQuery } from './models/ResourcesGetFileLocationRequestQuery'
import { ResourceLocationInfo } from './models/ResourceLocationInfo'
import { Model_1 } from './models/Model_1'
import { IdResponseOfString } from './models/IdResponseOfString'
import { WebChannelSeoConfig } from './models/WebChannelSeoConfig'
import { SessionsListRequestQuery } from './models/SessionsListRequestQuery'
import { PageOfWebUserSessionDto } from './models/PageOfWebUserSessionDto'
import { WebUserSessionDto } from './models/WebUserSessionDto'
import { WebUserDto } from './models/WebUserDto'
import { WebUserProfileDto } from './models/WebUserProfileDto'
import { UserTelegramDto } from './models/UserTelegramDto'
import { WebUserUpdate } from './models/WebUserUpdate'
import { WebUserProfileUpdate } from './models/WebUserProfileUpdate'
import { BindTelegramDto } from './models/BindTelegramDto'

@injectable()
@injectFromBase({ extendConstructorArguments: true })
export class AppApiGateway extends BaseApiGateWay {

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/analytics/config`,
    })
    analyticsConfig(showcaseHost: string): Promise<WebChannelAnalyticsConfig> {


      return WebChannelAnalyticsConfig.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/attributes`,
    })
    attributesList(showcaseHost: string): Promise<AttributesListDto> {


      return AttributesListDto.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/auth`,
    })
    authCheckSession(showcaseHost: string): Promise<SignInCompletedResponse> {


      return SignInCompletedResponse.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/auth/config`,
    })
    authAuthConfig(showcaseHost: string): Promise<WebChannelAuthConfig> {


      return WebChannelAuthConfig.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @POST({
      path: (showcaseHost: string, model: SignInRequest) => `/showcases/v1/${showcaseHost}/auth/sign-in`,
    })
    authSignIn(showcaseHost: string, model: SignInRequest): Promise<SignInBeginResponse> {
      // Оборачивание request payload в ActiveModel (для корректной сериализации)
      model = SignInRequest.createLazy(model)
      

      return SignInBeginResponse.asyncCreateLazy(this.send(model))

    }

    /**
    * 
    */
    @POST({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/auth/sign-in/anon`,
    })
    authSignInAnonym(showcaseHost: string): Promise<SignInCompletedResponse> {


      return SignInCompletedResponse.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @POST({
      path: (showcaseHost: string, model: SignUpRequest) => `/showcases/v1/${showcaseHost}/auth/sign-up`,
    })
    authSignUp(showcaseHost: string, model: SignUpRequest): Promise<BeginChallengeResponse> {
      // Оборачивание request payload в ActiveModel (для корректной сериализации)
      model = SignUpRequest.createLazy(model)
      

      return BeginChallengeResponse.asyncCreateLazy(this.send(model))

    }

    /**
    * 
    */
    @POST({
      path: (showcaseHost: string, model: ConfirmChallengeRequest) => `/showcases/v1/${showcaseHost}/auth/confirm`,
    })
    authConfirm(showcaseHost: string, model: ConfirmChallengeRequest): Promise<SignInCompletedResponse> {
      // Оборачивание request payload в ActiveModel (для корректной сериализации)
      model = ConfirmChallengeRequest.createLazy(model)
      

      return SignInCompletedResponse.asyncCreateLazy(this.send(model))

    }

    /**
    * 
    */
    @POST({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/auth/sign-out`,
    })
    authSignOut(showcaseHost: string): Promise<void> {


      return this.send()

    }

    /**
    * 
    */
    @POST({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/auth/sign-out/all`,
    })
    authSignOutAll(showcaseHost: string): Promise<void> {


      return this.send()

    }

    /**
    * 
    */
    @POST({
      path: (showcaseHost: string, model: MiniAppAuthRequest) => `/showcases/v1/${showcaseHost}/auth/mini-app`,
    })
    authMiniApp(showcaseHost: string, model: MiniAppAuthRequest): Promise<MiniAppAuthResponse> {
      // Оборачивание request payload в ActiveModel (для корректной сериализации)
      model = MiniAppAuthRequest.createLazy(model)
      

      return MiniAppAuthResponse.asyncCreateLazy(this.send(model))

    }

    /**
    * 
    */
    @POST({
      path: (showcaseHost: string, model: MiniAppSelectAccountRequest) => `/showcases/v1/${showcaseHost}/auth/mini-app/select`,
    })
    authMiniAppSelect(showcaseHost: string, model: MiniAppSelectAccountRequest): Promise<SignInCompletedResponse> {
      // Оборачивание request payload в ActiveModel (для корректной сериализации)
      model = MiniAppSelectAccountRequest.createLazy(model)
      

      return SignInCompletedResponse.asyncCreateLazy(this.send(model))

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/carts`,
    })
    cartsList(showcaseHost: string): Promise<CartInfo> {


      return CartInfo.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @PATCH({
      path: (showcaseHost: string, model: UpdateCart) => `/showcases/v1/${showcaseHost}/carts`,
    })
    cartsUpdate(showcaseHost: string, model: UpdateCart): Promise<CartInfo> {
      // Оборачивание request payload в ActiveModel (для корректной сериализации)
      model = UpdateCart.createLazy(model)
      

      return CartInfo.asyncCreateLazy(this.send(model))

    }

    /**
    * 
    */
    @DELETE({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/carts`,
    })
    cartsClear(showcaseHost: string): Promise<void> {


      return this.send()

    }

    /**
    * 
    */
    @DELETE({
      path: (productId: number, showcaseHost: string) => `/showcases/v1/${showcaseHost}/carts/${productId}`,
    })
    cartsRemoveProduct(productId: number, showcaseHost: string): Promise<CartInfo> {


      return CartInfo.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @PATCH({
      path: (productId: number, showcaseHost: string) => `/showcases/v1/${showcaseHost}/carts/${productId}/notify`,
    })
    cartsNotify(productId: number, showcaseHost: string): Promise<void> {


      return this.send()

    }

    /**
    * 
    */
    @DELETE({
      path: (productId: number, showcaseHost: string) => `/showcases/v1/${showcaseHost}/carts/${productId}/notify`,
    })
    cartsNotNotify(productId: number, showcaseHost: string): Promise<void> {


      return this.send()

    }

    /**
    * Гостю (анонимная сессия или запрос без сессии) акции, промокод и баллы не применяются —<br>то же правило, что и на оформлении (`OrdersController`): корзина обязана показывать<br>сумму, которую подтвердит заказ.<br>
    */
    @POST({
      path: (showcaseHost: string, model: CartPricingRequest) => `/showcases/v1/${showcaseHost}/carts/pricing`,
    })
    cartsPricing(showcaseHost: string, model: CartPricingRequest): Promise<CartPricingResponse> {
      // Оборачивание request payload в ActiveModel (для корректной сериализации)
      model = CartPricingRequest.createLazy(model)
      

      return CartPricingResponse.asyncCreateLazy(this.send(model))

    }

    /**
    * Анониму отказ той же формулировкой, что и на оформлении: иначе код сохранялся бы,<br>корзина показывала бы его применённым, а `orders/resolve` падал бы валидацией<br>и блокировал гостю оформление до очистки кода.<br>
    */
    @POST({
      path: (showcaseHost: string, model: SetPromoCodeRequest) => `/showcases/v1/${showcaseHost}/carts/promo-code`,
    })
    cartsSetPromoCode(showcaseHost: string, model: SetPromoCodeRequest): Promise<void> {
      // Оборачивание request payload в ActiveModel (для корректной сериализации)
      model = SetPromoCodeRequest.createLazy(model)
      

      return this.send(model)

    }

    /**
    * 
    */
    @DELETE({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/carts/promo-code`,
    })
    cartsClearPromoCode(showcaseHost: string): Promise<void> {


      return this.send()

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/categories`,
    })
    categoriesList(showcaseHost: string): Promise<ChannelCategoriesDto> {


      return ChannelCategoriesDto.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (categoryId: number, showcaseHost: string) => `/showcases/v1/${showcaseHost}/categories/${categoryId}/attributes`,
    })
    categoriesListAttributes(categoryId: number, showcaseHost: string): Promise<CategoryAttributesListDto> {


      return CategoryAttributesListDto.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string, query: CdekSuggestCitiesRequestQuery) => `/showcases/v1/${showcaseHost}/integrations/cdek/cities/search`,
      options: (showcaseHost: string, query: CdekSuggestCitiesRequestQuery) => ({
        query: CdekSuggestCitiesRequestQuery.createLazy(query)
      })
    })
    cdekSuggestCities(showcaseHost: string, query: CdekSuggestCitiesRequestQuery): Promise<Array<SDEKSuggestCityDto>> {


      return SDEKSuggestCityDto.asyncCreateFromCollectionLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string, query: CdekCitiesByLocationRequestQuery) => `/showcases/v1/${showcaseHost}/integrations/cdek/cities/coords`,
      options: (showcaseHost: string, query: CdekCitiesByLocationRequestQuery) => ({
        query: CdekCitiesByLocationRequestQuery.createLazy(query)
      })
    })
    cdekCitiesByLocation(showcaseHost: string, query: CdekCitiesByLocationRequestQuery): Promise<Array<SDEKSuggestCityDto>> {


      return SDEKSuggestCityDto.asyncCreateFromCollectionLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string, query: CdekOfficesRequestQuery) => `/showcases/v1/${showcaseHost}/integrations/cdek/offices`,
      options: (showcaseHost: string, query: CdekOfficesRequestQuery) => ({
        query: CdekOfficesRequestQuery.createLazy(query)
      })
    })
    cdekOffices(showcaseHost: string, query: CdekOfficesRequestQuery): Promise<Array<CdekLocation>> {


      return CdekLocation.asyncCreateFromCollectionLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string, query: ContentListRequestQuery) => `/showcases/v1/${showcaseHost}/content/items`,
      options: (showcaseHost: string, query: ContentListRequestQuery) => ({
        query: ContentListRequestQuery.createLazy(query)
      })
    })
    contentList(showcaseHost: string, query: ContentListRequestQuery): Promise<PageOfShowcaseContentListItemDto> {


      return PageOfShowcaseContentListItemDto.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (slug: string, showcaseHost: string) => `/showcases/v1/${showcaseHost}/content/items/by-slug/${slug}`,
    })
    contentGetBySlug(slug: string, showcaseHost: string): Promise<ShowcaseContentItemDto> {


      return ShowcaseContentItemDto.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/content/sitemap`,
    })
    contentSitemap(showcaseHost: string): Promise<Array<ShowcaseContentSitemapEntryDto>> {


      return ShowcaseContentSitemapEntryDto.asyncCreateFromCollectionLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/dictionaries/enums`,
    })
    dictionariesGetEnums(showcaseHost: string): Promise<Enumsregistry> {


      return Enumsregistry.asyncCreateLazy(this.send())

    }

    /**
    * В качестве поля сортировки допустимо передавать: <br><br>идентификатор атрибута, по значению которого сортировать; <br><br>одну из предопределённых констант: <br><br>    - created - сортировка по времени создания товара; <br><br>    - updated - сортировка по времени последнего изменения товара; <br><br>    - favCreated - сортировка по времени создания записи в избранном<br>
    */
    @GET({
      path: (showcaseHost: string, query: FavoritesProductsListGetRequestQuery) => `/showcases/v1/${showcaseHost}/favorites/products/search`,
      options: (showcaseHost: string, query: FavoritesProductsListGetRequestQuery) => ({
        query: FavoritesProductsListGetRequestQuery.createLazy(query)
      })
    })
    favoritesProductsListGet(showcaseHost: string, query: FavoritesProductsListGetRequestQuery): Promise<ProductListItemPage> {


      return ProductListItemPage.asyncCreateLazy(this.send())

    }

    /**
    * В качестве поля сортировки допустимо передавать: <br><br>идентификатор атрибута, по значению которого сортировать; <br><br>одну из предопределённых констант: <br><br>    - created - сортировка по времени создания товара; <br><br>    - updated - сортировка по времени последнего изменения товара; <br><br>    - favCreated - сортировка по времени создания записи в избранном<br>
    */
    @POST({
      path: (showcaseHost: string, model: ListingOptionsOfFavoriteProductsFilterOptions) => `/showcases/v1/${showcaseHost}/favorites/products/search`,
    })
    favoritesProductsListPost(showcaseHost: string, model: ListingOptionsOfFavoriteProductsFilterOptions): Promise<ProductListItemPage> {
      // Оборачивание request payload в ActiveModel (для корректной сериализации)
      model = ListingOptionsOfFavoriteProductsFilterOptions.createLazy(model)
      

      return ProductListItemPage.asyncCreateLazy(this.send(model))

    }

    /**
    * 
    */
    @POST({
      path: (productId: number, showcaseHost: string) => `/showcases/v1/${showcaseHost}/favorites/products/${productId}`,
    })
    favoritesProductsAdd(productId: number, showcaseHost: string): Promise<void> {


      return this.send()

    }

    /**
    * 
    */
    @DELETE({
      path: (productId: number, showcaseHost: string) => `/showcases/v1/${showcaseHost}/favorites/products/${productId}`,
    })
    favoritesProductsRemove(productId: number, showcaseHost: string): Promise<void> {


      return this.send()

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/feed/config`,
    })
    feedConfig(showcaseHost: string): Promise<WebChannelFeedConfig> {


      return WebChannelFeedConfig.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/loyalty/wallet`,
    })
    loyaltyGetWallet(showcaseHost: string): Promise<ShowcaseLoyaltyWalletDto> {


      return ShowcaseLoyaltyWalletDto.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string, query: LoyaltyListTransactionsRequestQuery) => `/showcases/v1/${showcaseHost}/loyalty/transactions`,
      options: (showcaseHost: string, query: LoyaltyListTransactionsRequestQuery) => ({
        query: LoyaltyListTransactionsRequestQuery.createLazy(query)
      })
    })
    loyaltyListTransactions(showcaseHost: string, query: LoyaltyListTransactionsRequestQuery): Promise<PageOfShowcaseLoyaltyTransactionDto> {


      return PageOfShowcaseLoyaltyTransactionDto.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string, query: NotificationsListRequestQuery) => `/showcases/v1/${showcaseHost}/notifications`,
      options: (showcaseHost: string, query: NotificationsListRequestQuery) => ({
        query: NotificationsListRequestQuery.createLazy(query)
      })
    })
    notificationsList(showcaseHost: string, query: NotificationsListRequestQuery): Promise<PageOfNotificationDto> {


      return PageOfNotificationDto.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string, query: NotificationsListCountRequestQuery) => `/showcases/v1/${showcaseHost}/notifications/count`,
      options: (showcaseHost: string, query: NotificationsListCountRequestQuery) => ({
        query: NotificationsListCountRequestQuery.createLazy(query)
      })
    })
    notificationsListCount(showcaseHost: string, query: NotificationsListCountRequestQuery): Promise<ItemsCount> {


      return ItemsCount.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @PATCH({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/notifications/view`,
    })
    notificationsMarkAllViewed(showcaseHost: string): Promise<void> {


      return this.send()

    }

    /**
    * 
    */
    @PATCH({
      path: (id: number, showcaseHost: string) => `/showcases/v1/${showcaseHost}/notifications/view/${id}`,
    })
    notificationsMarkViewed(id: number, showcaseHost: string): Promise<void> {


      return this.send()

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string, query: OrdersListRequestQuery) => `/showcases/v1/${showcaseHost}/orders`,
      options: (showcaseHost: string, query: OrdersListRequestQuery) => ({
        query: OrdersListRequestQuery.createLazy(query)
      })
    })
    ordersList(showcaseHost: string, query: OrdersListRequestQuery): Promise<PageOfOrderListDto> {


      return PageOfOrderListDto.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @POST({
      path: (showcaseHost: string, model: UpdateOrder) => `/showcases/v1/${showcaseHost}/orders`,
    })
    ordersCreate(showcaseHost: string, model: UpdateOrder): Promise<OrderDto> {
      // Оборачивание request payload в ActiveModel (для корректной сериализации)
      model = UpdateOrder.createLazy(model)
      

      return OrderDto.asyncCreateLazy(this.send(model))

    }

    /**
    * 
    */
    @GET({
      path: (orderId: number, showcaseHost: string) => `/showcases/v1/${showcaseHost}/orders/${orderId}`,
    })
    ordersGet(orderId: number, showcaseHost: string): Promise<OrderDto> {


      return OrderDto.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @PATCH({
      path: (orderId: number, showcaseHost: string, model: UpdateOrder) => `/showcases/v1/${showcaseHost}/orders/${orderId}`,
    })
    ordersUpdate(orderId: number, showcaseHost: string, model: UpdateOrder): Promise<OrderDto> {
      // Оборачивание request payload в ActiveModel (для корректной сериализации)
      model = UpdateOrder.createLazy(model)
      

      return OrderDto.asyncCreateLazy(this.send(model))

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/orders/config`,
    })
    ordersOrdersConfig(showcaseHost: string): Promise<WebChannelOrdersConfig> {


      return WebChannelOrdersConfig.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @POST({
      path: (showcaseHost: string, model: UpdateOrder) => `/showcases/v1/${showcaseHost}/orders/resolve`,
    })
    ordersResolve(showcaseHost: string, model: UpdateOrder): Promise<OrderDto> {
      // Оборачивание request payload в ActiveModel (для корректной сериализации)
      model = UpdateOrder.createLazy(model)
      

      return OrderDto.asyncCreateLazy(this.send(model))

    }

    /**
    * ApiVersion 1: способ задаётся строковым кодом Web.Api.Showcases.Controllers.Orders.Models.OrderPayRequestV1.PaymentMethod<br>(по умолчанию `Card`)<br>
    */
    @PATCH({
      path: (orderId: number, showcaseHost: string, model: OrderPayRequestV1) => `/showcases/v1/${showcaseHost}/orders/${orderId}/pay`,
    })
    ordersPayV1(orderId: number, showcaseHost: string, model: OrderPayRequestV1): Promise<OrderPaymentDto> {
      // Оборачивание request payload в ActiveModel (для корректной сериализации)
      model = OrderPayRequestV1.createLazy(model)
      

      return OrderPaymentDto.asyncCreateLazy(this.send(model))

    }

    /**
    * 
    */
    @PATCH({
      path: (orderId: number, showcaseHost: string) => `/showcases/v1/${showcaseHost}/orders/${orderId}/cancel`,
    })
    ordersCancel(orderId: number, showcaseHost: string): Promise<void> {


      return this.send()

    }

    /**
    * 
    */
    @GET({
      path: (key: string, showcaseHost: string) => `/showcases/v1/${showcaseHost}/page-blocks/by-key/${key}`,
    })
    pageBlocksGetByKey(key: string, showcaseHost: string): Promise<ShowcasePageBlockCarouselDto | ShowcasePageBlockProductCollectionDto> {


      return this.send<ShowcasePageBlockCarouselDto | ShowcasePageBlockProductCollectionDto>().then(response => {
        const discriminatorValue = response?.type
        switch (discriminatorValue) {
          case 'Carousel':
            return ShowcasePageBlockCarouselDto.createLazy(response)
          case 'ProductCollection':
            return ShowcasePageBlockProductCollectionDto.createLazy(response)
          default:
            return ShowcasePageBlockCarouselDto.createLazy(response)
        }
      })

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/product-collections`,
    })
    productCollectionsList(showcaseHost: string): Promise<Array<ShowcaseProductCollectionListItemDto>> {


      return ShowcaseProductCollectionListItemDto.asyncCreateFromCollectionLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string, query: ProductCollectionsPreviewRequestQuery) => `/showcases/v1/${showcaseHost}/product-collections/preview`,
      options: (showcaseHost: string, query: ProductCollectionsPreviewRequestQuery) => ({
        query: ProductCollectionsPreviewRequestQuery.createLazy(query)
      })
    })
    productCollectionsPreview(showcaseHost: string, query: ProductCollectionsPreviewRequestQuery): Promise<Array<ShowcaseProductCollectionPreviewDto>> {


      return ShowcaseProductCollectionPreviewDto.asyncCreateFromCollectionLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (id: number, showcaseHost: string) => `/showcases/v1/${showcaseHost}/product-collections/${id}`,
    })
    productCollectionsGet(id: number, showcaseHost: string): Promise<ShowcaseProductCollectionDto> {


      return ShowcaseProductCollectionDto.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (slug: string, showcaseHost: string) => `/showcases/v1/${showcaseHost}/product-collections/by-slug/${slug}`,
    })
    productCollectionsGetBySlug(slug: string, showcaseHost: string): Promise<ShowcaseProductCollectionDto> {


      return ShowcaseProductCollectionDto.asyncCreateLazy(this.send())

    }

    /**
    * В качестве поля сортировки допустимо передавать: <br><br>идентификатор атрибута, по значению которого сортировать; <br><br>одну из предопределённых констант: <br><br>    - created - сортировка по времени создания; <br><br>    - updated - сортировка по времени последнего изменения; <br><br>    - manual - ручной порядок витрины (закреплённые товары сверху: категория важнее ассортимента, остальное по новизне)<br>
    */
    @GET({
      path: (showcaseHost: string, query: ProductsListGetRequestQuery) => `/showcases/v1/${showcaseHost}/products/search`,
      options: (showcaseHost: string, query: ProductsListGetRequestQuery) => ({
        query: ProductsListGetRequestQuery.createLazy(query)
      })
    })
    productsListGet(showcaseHost: string, query: ProductsListGetRequestQuery): Promise<ProductListItemPage> {


      return ProductListItemPage.asyncCreateLazy(this.send())

    }

    /**
    * В качестве поля сортировки допустимо передавать: <br><br>идентификатор атрибута, по значению которого сортировать; <br><br>одну из предопределённых констант: <br><br>    - created - сортировка по времени создания; <br><br>    - updated - сортировка по времени последнего изменения; <br><br>    - manual - ручной порядок витрины (закреплённые товары сверху: категория важнее ассортимента, остальное по новизне)<br>
    */
    @POST({
      path: (showcaseHost: string, model: ListingOptionsOfProductFilterOptions) => `/showcases/v1/${showcaseHost}/products/search`,
    })
    productsListPost(showcaseHost: string, model: ListingOptionsOfProductFilterOptions): Promise<ProductListItemPage> {
      // Оборачивание request payload в ActiveModel (для корректной сериализации)
      model = ListingOptionsOfProductFilterOptions.createLazy(model)
      

      return ProductListItemPage.asyncCreateLazy(this.send(model))

    }

    /**
    * 
    */
    @GET({
      path: (productId: number, showcaseHost: string) => `/showcases/v1/${showcaseHost}/products/${productId}`,
    })
    productsGet(productId: number, showcaseHost: string): Promise<ProductDto> {


      return ProductDto.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (id: string, showcaseHost: string, query: ResourcesGetFileRequestQuery) => `/showcases/v1/${showcaseHost}/resources/file/${id}`,
      options: (id: string, showcaseHost: string, query: ResourcesGetFileRequestQuery) => ({
        query: ResourcesGetFileRequestQuery.createLazy(query)
      })
    })
    resourcesGetFile(id: string, showcaseHost: string, query: ResourcesGetFileRequestQuery): Promise<void> {


      return this.send()

    }

    /**
    * 
    */
    @GET({
      path: (id: string, showcaseHost: string, query: ResourcesGetFileLocationRequestQuery) => `/showcases/v1/${showcaseHost}/resources/location/${id}`,
      options: (id: string, showcaseHost: string, query: ResourcesGetFileLocationRequestQuery) => ({
        query: ResourcesGetFileLocationRequestQuery.createLazy(query)
      })
    })
    resourcesGetFileLocation(id: string, showcaseHost: string, query: ResourcesGetFileLocationRequestQuery): Promise<ResourceLocationInfo> {


      return ResourceLocationInfo.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @POST({
      path: (showcaseHost: string, model: Model_1) => `/showcases/v1/${showcaseHost}/resources`,
    })
    resourcesCreate(showcaseHost: string, model: Model_1): Promise<IdResponseOfString> {
      model = DataSerializer.toFormData(model)


      return IdResponseOfString.asyncCreateLazy(this.send(model))

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/seo/config`,
    })
    seoConfig(showcaseHost: string): Promise<WebChannelSeoConfig> {


      return WebChannelSeoConfig.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string, query: SessionsListRequestQuery) => `/showcases/v1/${showcaseHost}/users/sessions`,
      options: (showcaseHost: string, query: SessionsListRequestQuery) => ({
        query: SessionsListRequestQuery.createLazy(query)
      })
    })
    sessionsList(showcaseHost: string, query: SessionsListRequestQuery): Promise<PageOfWebUserSessionDto> {


      return PageOfWebUserSessionDto.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @DELETE({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/users/sessions`,
    })
    sessionsDeleteAll(showcaseHost: string): Promise<void> {


      return this.send()

    }

    /**
    * 
    */
    @GET({
      path: (sessionId: number, showcaseHost: string) => `/showcases/v1/${showcaseHost}/users/sessions/${sessionId}`,
    })
    sessionsGet(sessionId: number, showcaseHost: string): Promise<WebUserSessionDto> {


      return WebUserSessionDto.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @DELETE({
      path: (sessionId: number, showcaseHost: string) => `/showcases/v1/${showcaseHost}/users/sessions/${sessionId}`,
    })
    sessionsDelete(sessionId: number, showcaseHost: string): Promise<void> {


      return this.send()

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/users`,
    })
    usersGet(showcaseHost: string): Promise<WebUserDto> {


      return WebUserDto.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @PATCH({
      path: (showcaseHost: string, model: WebUserUpdate) => `/showcases/v1/${showcaseHost}/users`,
    })
    usersUpdate(showcaseHost: string, model: WebUserUpdate): Promise<void> {
      // Оборачивание request payload в ActiveModel (для корректной сериализации)
      model = WebUserUpdate.createLazy(model)
      

      return this.send(model)

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/users/telegram/bind-link/available`,
    })
    usersBindTelegramAvailable(showcaseHost: string): Promise<string> {


      return this.send()

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/users/telegram/bind-link`,
    })
    usersBindTelegram(showcaseHost: string): Promise<BindTelegramDto> {


      return BindTelegramDto.asyncCreateLazy(this.send())

    }

    /**
    * 
    */
    @GET({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/users/telegram/bind-link/redirect`,
    })
    usersBindTelegramRedirect(showcaseHost: string): Promise<void> {


      return this.send()

    }

    /**
    * 
    */
    @DELETE({
      path: (showcaseHost: string) => `/showcases/v1/${showcaseHost}/users/telegram`,
    })
    usersUnbindTelegram(showcaseHost: string): Promise<void> {


      return this.send()

    }

}
